module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--2-e14a77cd4bb1cfdfb0688df85b37179a.jpg";